/*
 * NFT Landing Page - Sailing Ships Collection
 * Copyright (C) 2025 jsaif
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * Original project: https://github.com/s-shemmee/NFT-Portfolio-Landing-Page
 * Original creator: s-shemmee
 */

// Shared team member data for Team and TeamModal components
export const teamMembers = [
  {
    name: "Jubi",
    jobTitle: "Visionary Creator & Master Ship Architect",
    role: "Founder & Lead Designer",
    description: "Crafting the story, spirit, and sparkle of every ship that sails through the cosmic realms.",
    expertise: ["NFT Design", "Blockchain Technology", "Digital Art", "Web Design"],
    achievements: [
      "Pioneer in cosmic NFT collections",
      "10+ years in digital art creation",
      "Leading expert in spaceship aesthetics",
      "Built thriving NFT communities",
    ],
    mission:
      "To bridge the gap between imagination and reality through revolutionary NFT experiences that transcend traditional boundaries.",
    quote:
      "Every ship tells a story, every collection builds a universe, and every holder becomes part of our cosmic journey.",
    socialLinks: {
      twitter: "https://x.com/jubi_25",
      linkedin: "https://linkedin.com/in/nftportfolio",
    },
    image: require("../images/Avatar-2.png"),
  },
];
